import { createAction } from '@reduxjs/toolkit'
import { ImportStatus } from '@tellimer/ui/ImportContacts'

export { ImportStatus } from '@tellimer/ui/ImportContacts'
export const updateImportStatus = createAction<ImportStatus>('importSubscribers/updateImportStatus')
